import axios from "axios";
import { useState, useEffect } from "react";

const useCompositionBoard = () => {
  const [boardInfo, setBoardInfo] = useState([]);
  const [loading, setLoading] = useState(false);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const url = `${rupali_api_url}/Api/WebSite/CompositionBoard`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setBoardInfo(res.data.data);
      setLoading(true);
    });
  }, []);

  return [boardInfo, setBoardInfo, loading];
};

export default useCompositionBoard;
